import { connect } from 'react-redux';
import { productionTimePopupDispatcher } from '../../../redux/product/product.dispatchers';
import { productionTimePopupSelector } from '../../../redux/product/product.selectors';
import { productionTimeForItemPopupSelector } from '../../../redux/cart/cart.selectors';
import { ProductionTimeDialog } from './production-time-dialog';
export const ProductionTimeDialogForProduct = connect(productionTimePopupSelector, productionTimePopupDispatcher)(ProductionTimeDialog);
export const ProductionTimeDialogForItem = connect(productionTimeForItemPopupSelector, productionTimePopupDispatcher)(ProductionTimeDialog);
export { ProductionTimeDialog } from './production-time-dialog';